import React from 'react';
import { useSelector } from 'react-redux';
import steps from 'src/config/steps.config';
import { getPacks, currentStepSelector } from 'src/redux/configurator/selectors';

const useSteps = () => {
  const packs = useSelector(getPacks);
  const currentStep = useSelector(currentStepSelector);

  return steps
    .filter(step => !step.packs || (step.packs && packs.length))
    .map((step, index) => ({
      ...step,
      number: index + 1,
      active: currentStep === index + 1,
    }));
};

export default useSteps;
